import useScrollTrigger from "@mui/material/useScrollTrigger";
import clsx from "clsx";
import * as React from "react";

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
  children: React.ReactElement<any>;
}

function ElevationScroll(props: Props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    // elevation: trigger ? 4 : 0,
    elevation: trigger ? 0 : 0,
    className: trigger ? clsx("elevated") : '',
  });
}

export default ElevationScroll;
